import "core-js/modules/es.symbol";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.map";
import "core-js/modules/es.date.to-string";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.get-own-property-descriptors";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.promise";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.split";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import axios from 'axios';
import _ from 'lodash';
import moment from 'moment'; // ------------------------------

var state = function state() {
  // 起点の日付は不要なバグを避けるため new Date で取得する
  var today = new Date(); // let today = new Date('2019-12-07');
  // let today = new Date('2020-01-04');
  // console.log(today);
  // new Date で取得した日付オブジェクトを、moment で加工し表記をそろえる
  // 【重要】この際に、moment の第二引数にフォーマットを指定しないと、Chrome 以外のブラウザでエラーが発生する（以降の moment メソッド使用時も同様）

  today = moment(today, 'YYYY-MM-DD').format('YYYY-MM-DD'); // console.log(today);

  return {
    api: '/api/calendars.json',
    date: today,
    calendar_list: []
  };
}; // ------------------------------


var getters = {
  // 年始かつ冬至期間中であるか判定
  isNewYear: function isNewYear(state) {
    try {
      var thisYear = moment(state.date, 'YYYY-MM-DD').format('YYYY');
      var dateFrom = "".concat(Number(thisYear) - 1, "-12-31");
      var dateTo = "".concat(thisYear, "-01-05"); // 年始かつ冬至の期間であれば true を返す

      if (moment(state.date, 'YYYY-MM-DD').isBetween(dateFrom, dateTo, 'day')) {
        return true;
      } else {
        return false;
      }
    } catch (error) {
      return false;
    }
  },
  // 対象日がどの期間に属するか
  // # 引数を取り、true / false を返すメソッドとして定義する
  checkBelong: function checkBelong(state) {
    return function (start, end) {
      var target = moment(state.date, 'YYYY-MM-DD');
      var startDate = moment(start, 'YYYY-MM-DD').add(-1, 'day').format('YYYY-MM-DD');
      var endDate = moment(end, 'YYYY-MM-DD').add(1, 'day').format('YYYY-MM-DD');

      if (target.isBetween(startDate, endDate, 'day')) {
        return true;
      } else {
        return false;
      }
    };
  },
  // 二十四節気データを整形して保持
  calendar: function calendar(state, getters) {
    try {
      // 副作用を防ぐため配列を cloneDeep する
      var calendarList = _.cloneDeep(state.calendar_list);

      calendarList = _.map(state.calendar_list, function (i) {
        // 計算用に年を保持する
        var thisYear = moment(state.date, 'YYYY-MM-DD').format('YYYY'); // 年始かつ冬至期間中の場合は基準年を前年に変更

        if (getters.isNewYear) {
          thisYear = moment(state.date, 'YYYY-MM-DD').add(-1, 'year').format('YYYY');
        } // console.log(thisYear);


        var period = i.period.split('-');
        var startDate = moment("".concat(thisYear, "-").concat(period[0]), 'YYYY-MM-DD').format('YYYY-MM-DD');
        var endDate = moment("".concat(thisYear, "-").concat(period[1]), 'YYYY-MM-DD').format('YYYY-MM-DD'); // 冬至は年をまたぐため返す年を 1 年追加する

        if (i.title === '冬至') {
          endDate = moment("".concat(Number(thisYear) + 1, "-").concat(period[1]), 'YYYY-MM-DD').format('YYYY-MM-DD');
        } // 対象日が期間に含まれているか判定


        var belong = getters.checkBelong(startDate, endDate);
        return _objectSpread({}, i, {
          startDate: startDate,
          endDate: endDate,
          belong: belong
        });
      }); // 節気の開始日で昇順ソート

      calendarList = _.sortBy(calendarList, 'startDate'); // console.log(calendarList);

      return calendarList;
    } catch (error) {
      console.error({
        error: error
      });
    }
  }
}; // ------------------------------

var mutations = {
  resetCalendarList: function resetCalendarList(state) {
    state.calendar_list = null;
  },
  setCalendarList: function setCalendarList(state, payload) {
    // 生の api の結果を state に登録
    state.calendar_list = payload.calendars;
  }
}; // ------------------------------

var actions = {
  getCalendarList: function () {
    var _getCalendarList = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee(_ref) {
      var commit, state, _ref2, data;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              commit = _ref.commit, state = _ref.state;
              _context.prev = 1;
              commit('resetCalendarList');
              _context.next = 5;
              return axios.get(state.api);

            case 5:
              _ref2 = _context.sent;
              data = _ref2.data;
              commit('setCalendarList', data);
              _context.next = 13;
              break;

            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](1);
              console.error("Error! HTTP states: ".concat(_context.t0));

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 10]]);
    }));

    function getCalendarList(_x) {
      return _getCalendarList.apply(this, arguments);
    }

    return getCalendarList;
  }()
}; // ------------------------------

export default {
  namespaced: true,
  state: state,
  actions: actions,
  mutations: mutations,
  getters: getters
};